import { RpcElectronOperation, RpcElectronOperationResult } from './rpc-electron-model';

/**
 * Rpc electron sever side handler interface.
 */
export interface RpcElectronRequestHandler {
    handler(data: RpcElectronOperation): Promise<RpcElectronOperationResult>;
}
